import React from 'react';
import { CheckCircle, Mail, Bike } from 'lucide-react';
import { PageType } from '../App';
interface ThankYouPageProps {
  navigate: (page: PageType) => void;
}
export function ThankYouPage({
  navigate
}: ThankYouPageProps) {
  return <div className="min-h-screen flex flex-col items-center justify-center p-4 relative overflow-hidden" data-id="element-296">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-297">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-gold-500/5 blur-[120px]" data-id="element-298" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-navy-700/50 blur-[120px]" data-id="element-299" />
      </div>

      <div className="max-w-2xl w-full bg-navy-700/50 border border-gold-500/20 rounded-2xl p-8 md:p-12 text-center shadow-2xl backdrop-blur-sm animate-fadeIn" data-id="element-300">
        <div className="w-24 h-24 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-8 border border-green-500/30 animate-scaleIn" data-id="element-301">
          <CheckCircle className="w-12 h-12 text-green-400" data-id="element-302" />
        </div>

        <h1 className="text-3xl md:text-5xl font-bold text-gold-500 mb-4 font-serif" data-id="element-303">
          Tu compra está confirmada
        </h1>

        <p className="text-xl text-gray-300 mb-8 font-light" data-id="element-304">
          Felicitaciones por dar el paso hacia un entrenamiento más inteligente
          y efectivo.
        </p>

        <div className="bg-navy-800/80 rounded-xl p-6 mb-8 text-left border border-navy-600" data-id="element-305">
          <h2 className="text-lg font-bold text-white mb-4 flex items-center" data-id="element-306">
            <Mail className="w-5 h-5 mr-2 text-gold-400" data-id="element-307" />
            ¿Qué pasa ahora?
          </h2>
          <ul className="space-y-4 text-gray-300" data-id="element-308">
            <li className="flex items-start" data-id="element-309">
              <span className="text-gold-500 mr-3 mt-1" data-id="element-310">•</span>
              <span data-id="element-311">
                En los próximos 5 minutos vas a recibir un correo electrónico
                con el asunto <strong data-id="element-312">"Tu acceso: PROTORRENDA 4-12"</strong>.
              </span>
            </li>
            <li className="flex items-start" data-id="element-313">
              <span className="text-gold-500 mr-3 mt-1" data-id="element-314">•</span>
              <span data-id="element-315">
                Allí encontrarás los enlaces de descarga directa para los 6
                Tomos y los 2 Bonos exclusivos.
              </span>
            </li>
            <li className="flex items-start" data-id="element-316">
              <span className="text-gold-500 mr-3 mt-1" data-id="element-317">•</span>
              <span data-id="element-318">
                El material está en formato PDF, listo para leer en cualquier
                dispositivo o imprimir.
              </span>
            </li>
          </ul>
        </div>

        <div className="text-gray-400 text-sm mb-8" data-id="element-319">
          <p data-id="element-320">
            ¿No recibiste el correo? Revisá tu carpeta de Spam o Promociones.
          </p>
          <p className="mt-2" data-id="element-321">Soporte: soporte@protorrenda.com</p>
        </div>

        <div className="pt-8 border-t border-navy-600 flex flex-col items-center" data-id="element-322">
          <Bike className="w-8 h-8 text-gold-500/50 mb-4" data-id="element-323" />
          <p className="text-gold-500/70 font-serif italic" data-id="element-324">by PROTORRENDA</p>
          <p className="text-xs text-gray-500 mt-2" data-id="element-325">
            Para el ciclista amateur argentino que entrena en serio.
          </p>
        </div>
      </div>
    </div>;
}